
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 3c-1.645 0-3 1.355-3 3 0 .352.074.684.188 1h-5.97l-.187.781-4 17-.031.094V27h26v-2.125l-.031-.094-4-17L24.78 7h-5.968A2.95 2.95 0 0019 6c0-1.645-1.355-3-3-3zm0 2c.563 0 1 .438 1 1 0 .563-.438 1-1 1-.563 0-1-.438-1-1 0-.563.438-1 1-1zM8.781 9H23.22l3.75 16H5.03zM15 12v1h-.5a2.497 2.497 0 00-2.5 2.5c0 1.383 1.117 2.5 2.5 2.5h3c.215 0 .5.285.5.5 0 .215-.285.5-.5.5H12v2h3v1h2v-1h.5c1.383 0 2.5-1.117 2.5-2.5S18.883 16 17.5 16h-3c-.215 0-.5-.285-.5-.5 0-.215.285-.5.5-.5H19v-2h-2v-1z"}})])
          )
        }
      }
    